import { BASE_URL } from './constants';
import { post } from './requestMethods';

const ACTIVITY_URL = `${BASE_URL}/api/user/activity`;

export type ActivitySignal = 'paywall_opened' | 'pricing_page_viewed' | 'trial_preview_viewed' | 'trial_project_edited';

export const ACTIVITY_API = {
  sendActivitySignal: (name: ActivitySignal): Promise<void> =>
    post<void>(ACTIVITY_URL, { data: { name } }).catch(() => undefined),
};
